import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { getSearchTerm, getSearchStatus } from 'app/pages/AgentSearch/modules/AgentItemsList';
import { Action } from 'app/pages/AgentSearch/actionTypes';
import GenericSearchWidget from 'app/shared/ui/GenericSearchWidget';
import { runAgentSearch } from 'app/pages/AgentSearch/commands';
import { AgentSearchStatus } from 'app/pages/AgentSearch/modules/AgentItemsList/state';

interface SearchWidgetProps {

}

interface StateProps {
    searchTerm: string 
    isLoading?: boolean
}

interface DispatchProps {
    changeSearchTerm: (value: string) => void
}

const mapStateToProps = (state:any, ownProps: SearchWidgetProps) : StateProps => {
    return {
        searchTerm: getSearchTerm(state),
        isLoading: getSearchStatus(state) === AgentSearchStatus.Running
    };
}

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>) : DispatchProps => ({
    changeSearchTerm: (term: string) => dispatch(runAgentSearch(term)) 
});

export default connect(mapStateToProps, mapDispatchToProps)(GenericSearchWidget);